import React from 'react';

const PresentationComponent = () => {
    const pdfUrl = "F+H_2026.pdf";
    // const pdfUrl = `https://drive.google.com/file/d/1sjpeN5BCaml288eV245IgpnLEZt8Qv_V/preview`;
    return (
        <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
            <iframe
                src={`${pdfUrl}`}
                title="Visor de PDF"
                width="100%"
                height="100%"
                style={{ border: 'none' }}
            />
        </div>
    );
};

export default PresentationComponent;